const linkNonActiveColor = "ghostwhite";
const linkActiveColor = "#53fbcd";

const headerHeight = "40px";

export { linkNonActiveColor, linkActiveColor, headerHeight };
